import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiPostFetcher, apiPutFetcher } from '@/common/api/fetcher'
import {
  ApprovalActionResponse,
  ApproveArticleApprovalVars,
  ArticleApprovalApiPath,
  CancelArticleApprovalResponse,
  CancelArticleApprovalVars,
  GetArticleApprovalResponse,
  GetArticleApprovalVars,
  ListArticleApprovalsResponse,
  ListArticleApprovalsVars,
  RejectArticleApprovalVars,
  UpdateArticleApprovalScheduleResponse,
  UpdateArticleApprovalScheduleVars
} from '@/common/api/params/articleApproval'

export const useArticleApprovalsListApi = (vars: ListArticleApprovalsVars | undefined) => {
  return useSWR<
    ListArticleApprovalsResponse,
    Response,
    [string, ListArticleApprovalsVars] | undefined
  >(vars ? [ArticleApprovalApiPath.LIST_ARTICLE_APPROVALS, vars] : undefined)
}

export const useArticleApprovalApi = (vars: GetArticleApprovalVars | undefined) => {
  return useSWR<GetArticleApprovalResponse, Response, [string, GetArticleApprovalVars] | undefined>(
    vars ? [ArticleApprovalApiPath.GET_ARTICLE_APPROVAL, vars] : undefined
  )
}

export const useApproveArticleApprovalApi = (options?: {
  onSuccess?: (response: ApprovalActionResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<ApprovalActionResponse, ApproveArticleApprovalVars>(
    ArticleApprovalApiPath.APPROVE_ARTICLE_APPROVAL,
    { ...options },
    apiPostFetcher
  )
}

export const useRejectArticleApprovalApi = (options?: {
  onSuccess?: (response: ApprovalActionResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<ApprovalActionResponse, RejectArticleApprovalVars>(
    ArticleApprovalApiPath.REJECT_ARTICLE_APPROVAL,
    { ...options },
    apiPostFetcher
  )
}

export const useCancelArticleApprovalApi = (options?: {
  onSuccess?: (response: CancelArticleApprovalResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<CancelArticleApprovalResponse, CancelArticleApprovalVars>(
    ArticleApprovalApiPath.CANCEL_ARTICLE_APPROVAL,
    { ...options },
    apiPostFetcher
  )
}

export const useUpdateArticleApprovalScheduleApi = (options?: {
  onSuccess?: (response: UpdateArticleApprovalScheduleResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<UpdateArticleApprovalScheduleResponse, UpdateArticleApprovalScheduleVars>(
    ArticleApprovalApiPath.UPDATE_ARTICLE_APPROVAL_SCHEDULE,
    { ...options },
    apiPutFetcher
  )
}
